module.exports = __webpack_public_path__ + "img/14.5c23074a.png";